export default "__VITE_ASSET__DG9EMaNz__"